// Canonical add-to-cart handler for every `new-product-card` instance across the theme.
// Loaded once, globally, from the header. Uses a single delegated listener so cards added
// later (AJAX load-more, popups, sliders) work automatically with no per-form rebinding.

let isRTL = false;
let notificationTimeout = null;

document.addEventListener('DOMContentLoaded', function() {
  isRTL = document.documentElement.getAttribute('dir') === 'rtl' ||
          document.body.getAttribute('dir') === 'rtl';
});

document.addEventListener('submit', function(e) {
  if (!e.target.matches('.new-product-card__form')) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  handleAddToCart(e);
}, true);

async function handleAddToCart(e) {
  const form = e.target;
  const button = form.querySelector('button[type="submit"]');
  if (!button) return;

  const productCard = form.closest('.new-product-card');
  const productImage = productCard ? productCard.querySelector('.new-product-card__image') : null;
  const formData = new FormData(form);

  const originalContent = button.innerHTML;
  button.disabled = true;
  button.setAttribute('data-loading', 'true');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    });

    const result = await response.json();

    if (response.ok) {
      const notification = showNotification(true);
      if (productImage) {
        createFlyingImage(productImage.src, button, notification);
      }
      if (window.PubSub) {
        window.PubSub.publish('update-header-cart-counter', result);
        window.PubSub.publish('cart-updated', result);
      }
    } else {
      showNotification(false, result.description || 'Could not add product. Please try again.');
    }
  } catch (error) {
    console.error('Add to cart error:', error);
    showNotification(false, 'Could not add product. Please try again.');
  } finally {
    setTimeout(() => {
      button.removeAttribute('data-loading');
      button.disabled = false;
      button.innerHTML = originalContent;
    }, 500);
  }
}

function showNotification(isSuccess, customMessage = null) {
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
    clearTimeout(notificationTimeout);
  }

  const notification = document.createElement('div');
  notification.className = `cart-notification ${isRTL ? 'rtl' : 'ltr'} ${isSuccess ? 'success' : 'error'}`;

  const message = customMessage || (isSuccess ?
    (isRTL ? 'تمت الإضافة بنجاح' : 'Added successfully') :
    (isRTL ? 'فشلت الإضافة. يرجى المحاولة مرة أخرى.' : 'Could not add product. Please try again.'));

  notification.innerHTML = `
    <div class="cart-notification__icon">${isSuccess ? '✓' : '!'}</div>
    <div class="cart-notification__message">${message}</div>
    <button class="cart-notification__close">&times;</button>
    <div class="cart-notification__progress">
      <div class="cart-notification__progress-bar"></div>
    </div>
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.classList.add('show');
  }, 10);

  notification.querySelector('.cart-notification__close').addEventListener('click', () => {
    notification.remove();
    clearTimeout(notificationTimeout);
  });

  notificationTimeout = setTimeout(() => {
    if (notification.parentNode) {
      notification.remove();
    }
  }, 2000);

  return notification;
}

function createFlyingImage(imageSrc, button, notification) {
  const buttonRect = button.getBoundingClientRect();
  const notificationRect = notification.getBoundingClientRect();

  const flyingImage = document.createElement('div');
  flyingImage.className = 'flying-image';
  flyingImage.style.position = 'fixed';
  flyingImage.style.left = `${buttonRect.left + buttonRect.width / 2}px`;
  flyingImage.style.top = `${buttonRect.top + buttonRect.height / 2}px`;
  flyingImage.innerHTML = `<img src="${imageSrc}" alt="Flying product image">`;

  document.body.appendChild(flyingImage);

  const destinationX = notificationRect.left + notificationRect.width / 2;
  const destinationY = notificationRect.top + notificationRect.height / 2;

  const startTime = Date.now();
  const duration = 1000;

  function animate() {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const ease = function(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const easedProgress = ease(progress);

    const currentX = buttonRect.left + buttonRect.width / 2 +
                    (destinationX - (buttonRect.left + buttonRect.width / 2)) * easedProgress;
    const currentY = buttonRect.top + buttonRect.height / 2 +
                    (destinationY - (buttonRect.top + buttonRect.height / 2)) * easedProgress;

    const scale = 1 - (0.8 * easedProgress);

    flyingImage.style.left = `${currentX}px`;
    flyingImage.style.top = `${currentY}px`;
    flyingImage.style.transform = `scale(${scale})`;

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      flyingImage.remove();
    }
  }

  requestAnimationFrame(animate);
}
